export const Config = {
	type: 'offers',
	lengthNameDesktop: 45,
	lengthNameMobile: 60,
};
